import strToBoolean from "utils/strToBoolean"


export function isDev() {
  return true;
  // return process.env.NODE_ENV === "development" && undefined === window.Cypress
}

export function isTest() {
  return process.env.NODE_ENV === "development" && undefined !== window.Cypress
}

export function isLocalHost() {
  return process.env.IS_LOCALHOST && strToBoolean(process.env.IS_LOCALHOST)
}
